module.exports = __webpack_public_path__ + "img/二级页面海报4G室内机.344e9c80.jpg";